import React from 'react';
import { colors, borderRadius, spacing } from '../../styles/tokens';

interface SkeletonLoaderProps {
  width?: string;
  height?: string;
  circle?: boolean;
  style?: React.CSSProperties;
}

export const SkeletonLoader: React.FC<SkeletonLoaderProps> = ({
  width = '100%',
  height = spacing.sm,
  circle = false,
  style = {},
}) => {
  return (
    <div
      style={{
        ...styles.skeleton,
        width,
        height,
        borderRadius: circle ? '50%' : borderRadius.sm,
        ...style,
      }}
      role="status"
      aria-label="Loading..."
    />
  );
};

const pulseAnimation = `
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
`;

const styles = {
  skeleton: {
    backgroundColor: colors.gray200,
    animation: 'pulse 1.5s ease-in-out infinite',
    display: 'inline-block',
  },
};

// Inject keyframes into document
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = pulseAnimation;
  document.head.appendChild(styleSheet);
}
